import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export class BusinessBookingOptions {
    public id: number = 0;
    public businessId: number = 0;
    public allowBooking: boolean = false;
    public remarks?: string;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Businesses;
    }

    public get permissionsIdToCheck(): number {
        return this.businessId;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): BusinessBookingOptions {
        const businessBookingOptions: BusinessBookingOptions = new BusinessBookingOptions();

        businessBookingOptions.id = this.id;
        businessBookingOptions.businessId = this.businessId;
        businessBookingOptions.allowBooking = this.allowBooking;
        businessBookingOptions.remarks = this.remarks;

        return businessBookingOptions;
    }
}
